/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Sandboxshell_Releasestatus_Datepending3Inputs */

const id_components_sandboxshell_releasestatus_datepending3 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Datepending3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tanggal tertunda`)
};

const ms_components_sandboxshell_releasestatus_datepending3 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Datepending3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarikh tertunda`)
};

const da_components_sandboxshell_releasestatus_datepending3 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Datepending3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dato ventende`)
};

const de_components_sandboxshell_releasestatus_datepending3 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Datepending3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datum ausstehend`)
};

const en_us2_components_sandboxshell_releasestatus_datepending3 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Datepending3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Date pending`)
};

const es_es2_components_sandboxshell_releasestatus_datepending3 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Datepending3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fecha pendiente`)
};

const es_mx2_components_sandboxshell_releasestatus_datepending3 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Datepending3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fecha pendiente`)
};

const fil_components_sandboxshell_releasestatus_datepending3 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Datepending3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nakabinbin ang petsa`)
};

const fr_components_sandboxshell_releasestatus_datepending3 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Datepending3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Date en attente`)
};

const it_components_sandboxshell_releasestatus_datepending3 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Datepending3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data in sospeso`)
};

const hu_components_sandboxshell_releasestatus_datepending3 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Datepending3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dátum függőben`)
};

const nl_components_sandboxshell_releasestatus_datepending3 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Datepending3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datum in behandeling`)
};

const no_components_sandboxshell_releasestatus_datepending3 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Datepending3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dato venter`)
};

const pl_components_sandboxshell_releasestatus_datepending3 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Datepending3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data oczekująca`)
};

const pt_br2_components_sandboxshell_releasestatus_datepending3 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Datepending3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Date Pending`)
};

const pt_components_sandboxshell_releasestatus_datepending3 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Datepending3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data pendente`)
};

const ro_components_sandboxshell_releasestatus_datepending3 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Datepending3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dată în așteptare`)
};

const fi_components_sandboxshell_releasestatus_datepending3 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Datepending3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Päivämäärä odottaa`)
};

const sv_components_sandboxshell_releasestatus_datepending3 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Datepending3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datum väntar`)
};

const vi_components_sandboxshell_releasestatus_datepending3 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Datepending3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ngày đang chờ`)
};

const tr_components_sandboxshell_releasestatus_datepending3 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Datepending3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarih bekleniyor`)
};

const cs_components_sandboxshell_releasestatus_datepending3 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Datepending3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datum se očekává`)
};

const bg_components_sandboxshell_releasestatus_datepending3 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Datepending3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Датата се очаква`)
};

const ru_components_sandboxshell_releasestatus_datepending3 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Datepending3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дата ожидается`)
};

const uk_components_sandboxshell_releasestatus_datepending3 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Datepending3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дата очікується`)
};

const ar_components_sandboxshell_releasestatus_datepending3 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Datepending3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تاريخ معلق`)
};

const hi_components_sandboxshell_releasestatus_datepending3 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Datepending3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`तारीख़ लंबित`)
};

const th_components_sandboxshell_releasestatus_datepending3 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Datepending3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รอวันที่`)
};

const ja_components_sandboxshell_releasestatus_datepending3 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Datepending3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`日付未定`)
};

const zh_cn2_components_sandboxshell_releasestatus_datepending3 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Datepending3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Date Pending`)
};

const zh_hant1_components_sandboxshell_releasestatus_datepending3 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Datepending3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Date Pending`)
};

const ko_components_sandboxshell_releasestatus_datepending3 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Datepending3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Date Pending`)
};

/**
* | output |
* | --- |
* | "Date pending" |
*
* @param {Components_Sandboxshell_Releasestatus_Datepending3Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_sandboxshell_releasestatus_datepending3 = /** @type {((inputs?: Components_Sandboxshell_Releasestatus_Datepending3Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Sandboxshell_Releasestatus_Datepending3Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_sandboxshell_releasestatus_datepending3(inputs)
	if (locale === "ms") return ms_components_sandboxshell_releasestatus_datepending3(inputs)
	if (locale === "da") return da_components_sandboxshell_releasestatus_datepending3(inputs)
	if (locale === "de") return de_components_sandboxshell_releasestatus_datepending3(inputs)
	if (locale === "en-US") return en_us2_components_sandboxshell_releasestatus_datepending3(inputs)
	if (locale === "es-ES") return es_es2_components_sandboxshell_releasestatus_datepending3(inputs)
	if (locale === "es-MX") return es_mx2_components_sandboxshell_releasestatus_datepending3(inputs)
	if (locale === "fil") return fil_components_sandboxshell_releasestatus_datepending3(inputs)
	if (locale === "fr") return fr_components_sandboxshell_releasestatus_datepending3(inputs)
	if (locale === "it") return it_components_sandboxshell_releasestatus_datepending3(inputs)
	if (locale === "hu") return hu_components_sandboxshell_releasestatus_datepending3(inputs)
	if (locale === "nl") return nl_components_sandboxshell_releasestatus_datepending3(inputs)
	if (locale === "no") return no_components_sandboxshell_releasestatus_datepending3(inputs)
	if (locale === "pl") return pl_components_sandboxshell_releasestatus_datepending3(inputs)
	if (locale === "pt-BR") return pt_br2_components_sandboxshell_releasestatus_datepending3(inputs)
	if (locale === "pt") return pt_components_sandboxshell_releasestatus_datepending3(inputs)
	if (locale === "ro") return ro_components_sandboxshell_releasestatus_datepending3(inputs)
	if (locale === "fi") return fi_components_sandboxshell_releasestatus_datepending3(inputs)
	if (locale === "sv") return sv_components_sandboxshell_releasestatus_datepending3(inputs)
	if (locale === "vi") return vi_components_sandboxshell_releasestatus_datepending3(inputs)
	if (locale === "tr") return tr_components_sandboxshell_releasestatus_datepending3(inputs)
	if (locale === "cs") return cs_components_sandboxshell_releasestatus_datepending3(inputs)
	if (locale === "bg") return bg_components_sandboxshell_releasestatus_datepending3(inputs)
	if (locale === "ru") return ru_components_sandboxshell_releasestatus_datepending3(inputs)
	if (locale === "uk") return uk_components_sandboxshell_releasestatus_datepending3(inputs)
	if (locale === "ar") return ar_components_sandboxshell_releasestatus_datepending3(inputs)
	if (locale === "hi") return hi_components_sandboxshell_releasestatus_datepending3(inputs)
	if (locale === "th") return th_components_sandboxshell_releasestatus_datepending3(inputs)
	if (locale === "ja") return ja_components_sandboxshell_releasestatus_datepending3(inputs)
	if (locale === "zh-CN") return zh_cn2_components_sandboxshell_releasestatus_datepending3(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_sandboxshell_releasestatus_datepending3(inputs)
	return ko_components_sandboxshell_releasestatus_datepending3(inputs)
});
export { components_sandboxshell_releasestatus_datepending3 as "components.sandboxShell.releaseStatus.datePending" }